import { render, staticRenderFns } from "./course2.vue?vue&type=template&id=4fd1561d&scoped=true&"
import script from "./course2.vue?vue&type=script&lang=js&"
export * from "./course2.vue?vue&type=script&lang=js&"
import style0 from "./course2.vue?vue&type=style&index=0&id=4fd1561d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1561d",
  null
  
)

export default component.exports